// สวิตช์เปิด/ปิดว่าจะดึงเนื้อหาไหนมาแสดงในเมนูไหน — บันทึกทันที ไม่มีปุ่ม Save ให้ลืมกด
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Brand, BrandFeatures } from "@contracts/api";
import { brandKeys } from "@features/brands/api/brands-api";
import { MENU_ICONS } from "@shared/ui/menu-icons";
import { cn } from "@shared/lib/utils";
import { updateBrand } from "../api/settings-api";
import { BRAND_FEATURES } from "../model/setting-menus";

export function FeatureRows({ brand }: { brand: Brand }) {
  const qc = useQueryClient();
  const save = useMutation({
    // ส่งเฉพาะคีย์ที่กด — server merge ให้ (jsonb ||) จึงกดหลายตัวติดกันแล้วไม่ทับกัน
    mutationFn: (features: Partial<BrandFeatures>) => updateBrand(brand.id, { features }),
    onSuccess: (saved) => {
      qc.setQueryData<Brand[]>(brandKeys.all, (list) =>
        (list ?? []).map((b) => (b.id === saved.id ? saved : b)),
      );
    },
  });

  return (
    <div className="feature-rows">
      {BRAND_FEATURES.map((x) => {
        const on = brand.features?.[x.key] !== false;
        const Icon = MENU_ICONS[x.icon];
        return (
          <div className="feature-row" key={x.key}>
            <span className="row-icon">
              <Icon />
            </span>
            <span className="grow">
              <span className="provider-name">{x.label}</span>
              <span className="provider-status muted">→ {x.target}</span>
            </span>
            <button
              type="button"
              className={cn("switch", on && "on")}
              role="switch"
              aria-checked={on}
              aria-label={`แสดง ${x.label}`}
              disabled={save.isPending}
              onClick={() => save.mutate({ [x.key]: !on })}
            >
              <span className="switch-dot" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
